(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.type = this.getAttribute('data-type');
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get playVideoButton() {
      return this.querySelector('.yg-play-video');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getYGVideoLoader().observe(this);
      }
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('hide');
      this.playVideoButton?.classList.add('hide');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        
        this.videoContainer.classList.remove('hide');
        videos.forEach(video => {
          video.play();
        });

        return;
      }

      this.appendChild(this.template?.content.cloneNode(true));
    }

    pauseVideo() {
      this.image?.classList.remove('hide');
      this.playVideoButton?.classList.remove('hide');
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        this.videoContainer.classList.add('hide');

        videos.forEach(video => {
          video.pause();
          video.currentTime = 0;
        });
      } else {
        this.videoContainer?.remove();
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
